import { useState, useEffect } from "react"
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faCircleNotch, faCreditCard, faRotate, faEye } from '@fortawesome/free-solid-svg-icons'
import Modal from 'react-modal';
import { Link } from "react-router-dom";

function LoanHistory({loan}) {
  const { user } = useUser();
  const [modalIsOpen2, setIsOpen2] = useState(false);
  const [loading, setLoading] = useState(false);
  const renewLoan = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/loan.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
        "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_renew: true, reference : loan.reference })
    })
    .then(response => response.json())
    .then(data => {
        console.log(data)
        if (data.status === "success") {
            setLoading(false);
            toast.success(data.result);
            setTimeout(() => {
                window.location.href = "loan";
            }, 2000);
        }else{
            toast.error(data.message);
            setLoading(false);
        }
    })
    .catch(err => {
        console.error(err)
        setLoading(false);
    })
  }

  const [modalIsOpen, setIsOpen] = useState(false);
  return (
    <>
      <tr>
          <td className="fw-semibold text-nowrap pt-0 d-md-table-cell d-none"><img src={loan.logo} alt="Asset" style={{width: '30px'}}/> {loan.symbol}</td>
          <td className="text-nowrap pt-0">{loan.amount}</td>
          <td className="text-nowrap pt-0 d-lg-table-cell d-none">{loan.collateral} {loan.c_symbol}</td>
          <td className="text-nowrap pt-0 d-lg-table-cell d-none">{loan.interest_amount}</td>
          <td className="text-nowrap pt-0">
              <span className="text-nowrap px-3 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520'}}>{loan.interest_rate}%</span>
          </td>
          <td className="text-nowrap pt-0 d-md-table-cell d-none">{loan.remaining}</td>
          <td className="text-nowrap pt-0 d-lg-table-cell d-none">{loan.start}</td>
          <td className="text-nowrap pt-0 d-lg-table-cell d-none">{loan.expired}</td>
          <td><span className={`${loan.status === 'pending' ? 'status-warning' : loan.status === 'overdue' || loan.status === 'rejected' ? 'status-danger' : 'status-success'}`}>{loan.status.charAt(0).toUpperCase() + loan.status.slice(1)}</span></td>
          <td className="d-md-table-cell d-none">
              <div className="d-flex align-items-center">
                  {(loan.status == "ongoing" || loan.status == "overdue") && (
                  <div className="px-3 py-2 d-flex align-items-center rounded-2 me-2" style={{backgroundColor: '#ffffff06',textDecoration:'none',cursor:'pointer'}}>
                      <FontAwesomeIcon icon={faRotate} style={{fontSize: '12px'}} className="text-prime" /> <p className="mb-0 fw-semibold text-prime ms-1" style={{fontSize: '12px'}} onClick={() => {setIsOpen2(false);setIsOpen(true);}}>Renew</p>
                  </div>
                  )}
                  {(loan.status == "ongoing" || loan.status == "overdue") && (
                  <Link to="/deposit" state={{route: 'loanrepayment'}} 
                  onClick={() => { 
                    localStorage.setItem('deposit.loanID', loan.loan_id);
                    localStorage.setItem('deposit.reference', loan.reference);
                  }}
                  className="px-3 py-2 d-flex align-items-center rounded-2 bg-prime" style={{textDecoration:'none',cursor:'pointer'}}>
                      <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '12px'}} /> <p className="mb-0 fw-semibold ms-1" style={{fontSize: '12px'}}>Repay</p>
                  </Link>
                  )}
              </div>
          </td>
          <td className="d-md-none d-table-cell"><div className="mycard px-2 py-1" onClick={() => setIsOpen2(true)}><FontAwesomeIcon icon={faEye} style={{fontSize: '12px'}} /></div></td>
      </tr>
      <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode1"
      >
          <div className="d-flex align-items-center justify-content-between">
              <p className="mb-0 fw-bold text-prime" style={{fontSize: '12px'}}>RENEW LOAN</p>
              <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
          </div>
          <div><img src={loan.logo} alt="Method" style={{width: '20px'}} /> <span className='fw-bold text-nowrap'>{Number(loan.amount).toFixed(5)} {loan.symbol}</span></div>
          <hr/>
          <div className="d-flex align-items-center justify-content-between mb-2">
              <p className="mb-0 fw-bold">Interest Rate:</p>
              <p className="mb-0">{loan.interest_amount} ({loan.interest_rate}%)</p>
          </div>
          <div className="d-flex align-items-center justify-content-between mb-2">
              <p className="mb-0 fw-bold">Remaining Principal:</p>
              <p className="mb-0">{loan.remaining}</p>
          </div>
          <div className="d-flex align-items-center justify-content-between mb-2">
              <p className="mb-0 fw-bold">Collateral</p> 
              <p className="mb-0"><img src={loan.c_logo} alt="Method" style={{width: '20px'}} /> <span className='fw-bold text-nowrap'>{Number(loan.collateral).toFixed(5)}  {loan.c_symbol}</span></p>
          </div>
          <div className="d-flex align-items-center justify-content-between mb-2">
              <p className="mb-0 fw-bold">Expired Date:</p>
              <p className="mb-0">{loan.expired}</p>
          </div>
          <div className={`myBtn px-3 py-2 mt-3 d-inline-block fw-semibold`} style={{cursor:'pointer'}} onClick={renewLoan}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Renew'}
          </div>
      </Modal>      
      <Modal
        isOpen={modalIsOpen2}
        onRequestClose={() => setIsOpen2(false)}
        shouldCloseOnOverlayClick={true} 
        closeTimeoutMS={100}
        className="shortmode1"
      >
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-prime" style={{fontSize: '12px'}}>Loan Details</p>
            <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen2(false)} />
        </div>
        <div><img src={loan.logo} alt="Method" style={{width: '20px'}} /> <span className='fw-bold text-nowrap'>{loan.amount} {loan.symbol}</span></div>
        <hr/>
        <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="mb-0 fw-bold">Collateral Amount ({loan.c_symbol})</p>
            <p className="mb-0">{loan.collateral}</p>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="mb-0 fw-bold">Residual Interest ({loan.symbol})</p>
            <p className="mb-0">{loan.interest_amount}</p>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="mb-0 fw-bold">Rate</p>
            <span className="text-nowrap px-3 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520'}}>{loan.interest_rate}%</span>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="mb-0 fw-bold">Remaining Principal ({loan.symbol})</p>
            <p className="mb-0">{loan.remaining}</p>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="mb-0 fw-bold">Date Started</p>
            <p className="mb-0">{loan.start}</p>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="mb-0 fw-bold">Expired Date</p>
            <p className="mb-0">{loan.expired}</p>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="mb-0 fw-bold">Status</p>
            <span className={`${loan.status === 'pending' ? 'status-warning' : loan.status === 'overdue' || loan.status === 'rejected' ? 'status-danger' : 'status-success'}`}>{loan.status.charAt(0).toUpperCase() + loan.status.slice(1)}</span>
        </div>
        <div className="d-flex align-items-center" style={{gap:'10px'}}>
          {(loan.status == "ongoing" || loan.status == "overdue") && (
          <div className="px-3 py-2 d-flex align-items-center rounded-2 me-2" style={{backgroundColor: '#ffffff06',textDecoration:'none',cursor:'pointer'}}>
              <FontAwesomeIcon icon={faRotate} style={{fontSize: '12px'}} className="text-prime" /> <p className="mb-0 fw-semibold text-prime ms-1" style={{fontSize: '12px'}} onClick={() => {setIsOpen2(false);setIsOpen(true);}}>Renew</p>
          </div>
          )}
          {(loan.status == "ongoing" || loan.status == "overdue") && (
          <Link to="/deposit" state={{route: 'loanrepayment'}} 
            onClick={() => { 
                localStorage.setItem('deposit.loanID', loan.loan_id);
                localStorage.setItem('deposit.reference', loan.reference);
            }}
            className="px-3 py-2 d-flex align-items-center rounded-2 bg-prime" style={{textDecoration:'none',cursor:'pointer'}}>
              <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '12px'}} /> <p className="mb-0 fw-semibold ms-1" style={{fontSize: '12px'}}>Repay</p>
          </Link>
          )}
        </div>
      </Modal>
    </>            
  )
}

export default LoanHistory